import { render, staticRenderFns } from "./EditInsurer.vue?vue&type=template&id=393c6766&scoped=true&"
import script from "./EditInsurer.vue?vue&type=script&lang=js&"
export * from "./EditInsurer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c6766",
  null
  
)

export default component.exports